import { render, staticRenderFns } from "./userTableTop.vue?vue&type=template&id=51a0202b&scoped=true"
import script from "./userTableTop.vue?vue&type=script&lang=js"
export * from "./userTableTop.vue?vue&type=script&lang=js"
import style0 from "./userTableTop.vue?vue&type=style&index=0&id=51a0202b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a0202b",
  null
  
)

export default component.exports